import * as Sentry from "@sentry/tanstackstart-react";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { LoadingSpinner } from "./routes/__root";

export function getRouter() {
  const router = createRouter({
    routeTree,
    defaultPreload: "intent",
    scrollRestoration: true,
    defaultPendingComponent: LoadingSpinner,
    defaultPendingMs: 0,
  });

  if (!router.isServer) {
    Sentry.init({
      dsn: "https://bc2322d452cedca7cecc09b5834cb4b0@o4510853861015552.ingest.de.sentry.io/4511191370694736",
      sendDefaultPii: false,
      tunnel: "/sntry-tnl",
      enabled: true,
      environment: process.env.NODE_ENV,
    });
  }

  return router;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
